import { render, staticRenderFns } from "./promotional.vue?vue&type=template&id=648b6003&"
import script from "./promotional.vue?vue&type=script&lang=js&"
export * from "./promotional.vue?vue&type=script&lang=js&"
import style0 from "./promotional.vue?vue&type=style&index=0&id=648b6003&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports